<div id="upload-image-mobile" >

  <div class="mt-3">
    <kl-farmer-membership-form [farmerMembershipDetails]="farmerMemberShipDetails" (closeDialog)="cancel()"></kl-farmer-membership-form>
  </div>

</div>
